import { type DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { type Dispatch } from "redux"
import { fetchAllExpenseAccounts } from "~Shared/store/actions/expenseAccount/expenseAccountActions"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"

export const subscribeToExpenseAccount = (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    try {
        if (
            operationType === OperationTypeEnum.INSERT ||
            operationType === OperationTypeEnum.UPDATE ||
            operationType === OperationTypeEnum.DELETE ||
            operationType === OperationTypeEnum.BULK_UPDATE
        ) {
            dispatch(fetchAllExpenseAccounts())
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Expense Account Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
